import { Bot } from "lucide-react";
import { Link } from "../lib/router";
export default function NotFound(){return <div className="not-found"><Bot/><h1>404</h1><h2>Essa conversa se perdeu no caminho.</h2><p>Volte ao painel e escolha um novo cenário.</p><Link href="/dashboard" className="primary-button">Voltar ao início</Link></div>}
